const stats = [
  { value: '5+', label: 'Years Experience' },
  { value: '135+', label: 'Countries Served' },
  { value: '600+', label: 'Professionals' },
  { value: '2K+', label: 'Happy Clients' },
];

function TrustStrip() {
  return (
    <section className="bg-white border-b border-gray-100">
      <div className="container mx-auto px-4 py-6 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
        {stats.map((stat) => (
          <div key={stat.label}>
            <p className="font-heading font-bold text-2xl text-[#0b1220]">{stat.value}</p>
            <p className="text-xs uppercase tracking-widest text-gray-500 mt-1">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default TrustStrip;
